import axios from "axios";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getEnquiriesList = (enquiryData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_ENQUIRIES_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/enquiries/list`,
        enquiryData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_ENQUIRIES_LIST_SUCCESS", payload: data });
      } else {
        dispatch({ type: "GET_ENQUIRIES_LIST_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "GET_ENQUIRIES_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};

export const getUserEnquiriesList = (enquiryData) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "GET_ENQUIRIES_LIST_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const { data } = await axios.post(
        `${BASE_URL}/enquiries/user-list`,
        enquiryData,
        config
      );
      if (data.statusCode === 200) {
        dispatch({ type: "GET_ENQUIRIES_LIST_SUCCESS", payload: data });
        return data;
      } else {
        dispatch({ type: "GET_ENQUIRIES_LIST_FAILED", payload: data });
        return data;
      }
    } catch (error) {
      dispatch({
        type: "GET_ENQUIRIES_LIST_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};


export const viewUserEnquiry = (enquiryId) => {
  return async (dispatch) => {
    dispatch({ type: "START_LOADING" });
    try {
      dispatch({ type: "VIEW_ENQUIRY_REQUEST" });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await axios.get(
        `${BASE_URL}/enquiries/view/${enquiryId}`,
        config
      );

      if (data.statusCode === 200) {
        dispatch({ type: "VIEW_ENQUIRY_SUCCESS", payload: data });
      } else {
        dispatch({ type: "VIEW_ENQUIRY_FAILED", payload: data });
      }
    } catch (error) {
      dispatch({
        type: "VIEW_ENQUIRY_FAILED",
        payload: error?.response?.data?.message,
      });
    } finally {
      dispatch({ type: "STOP_LOADING" });
    }
  };
};
